module.exports = __webpack_public_path__ + "img/acme-icon.68e14029.png";